require("./bootstrap");

$(function() {
  $.ajaxSetup({
    headers: {
      "X-CSRF-TOKEN": document.head.querySelector('meta[name="csrf-token"]')
        .content
    }
  });

  $("#language-selector").on("change", function(e) {
    $.post("/change-language", {
      language: $(this).val()
    }).then(resp => {
      location.reload();
    });
  });

  window.sr = ScrollReveal();
  sr.reveal(".slide-text", {
    delay: 200,
    reset: true
  });

  // Positive message timeout
  setTimeout(function() {
    $(".message.positive").animate(
      {
        height: "toggle",
        opacity: "toggle"
      },
      500
    );
  }, 5000);

  // Accordion
  if ($(".toggle .toggle-title").hasClass("active")) {
    $(".toggle .toggle-title.active")
      .closest(".toggle")
      .find(".toggle-inner")
      .show();
  }
  $(".toggle .toggle-title").click(function() {
    if ($(this).hasClass("active")) {
      $(this)
        .removeClass("active")
        .closest(".toggle")
        .find(".toggle-inner")
        .slideUp(200);
    } else {
      $(this)
        .addClass("active")
        .closest(".toggle")
        .find(".toggle-inner")
        .slideDown(200);
    }
  });

  // Default Slick Slider
  $(".default-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    cssEase: "linear",
    autoplay: true,
    autoplaySpeed: 4000
  });

  // Convert .svg image to SVG format (add class="svg")
  $("img.svg").each(function() {
    var $img = $(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");

    $.get(
      imgURL,
      function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find("svg");

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }

        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr("xmlns:a");

        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      "xml"
    );
  });
});

function thisURL(params) {
  var url,
    thisURL = document.location.pathname;

  if (params === 1) {
    // option = 1 = full page name with all parameters eg: products.php?id_product=1
    thisURLwithParam = thisURL.substring(
      0,
      thisURL.indexOf("#") == -1 ? thisURL.length : thisURL.indexOf("#")
    );
    thisURLwithParam = thisURLwithParam.substring(
      0,
      getPosition(thisURL, "/", 2)
    );
    url = thisURLwithParam;
  } else {
    // option = null = just the page name (eg: products.php)
    thisURL = thisURL.substring(
      0,
      thisURL.indexOf("#") == -1 ? thisURL.length : thisURL.indexOf("#")
    );
    thisURL = thisURL.substring(
      0,
      thisURL.indexOf("?") == -1 ? thisURL.length : thisURL.indexOf("?")
    );
    thisURL = thisURL.substring(0, getPosition(thisURL, "/", 2));
    url = thisURL;
  }

  if (url == "/") {
    url = "/home";
  }

  return url;
}

function thisSubURL(params) {
  var url,
    thisSubURL = document.location.pathname;

  if (params === 1) {
    // option = 1 = full page name with all parameters eg: products.php?id_product=1
    thisURLwithParam = thisSubURL.substring(
      0,
      thisSubURL.indexOf("#") == -1
        ? thisSubURL.length
        : thisSubURL.indexOf("#")
    );
    thisURLwithParam = thisURLwithParam.substring(
      0,
      getPosition(thisSubURL, "/", 3)
    );
    url = thisURLwithParam;
  } else {
    // option = null = just the page name (eg: products.php)
    thisSubURL = thisSubURL.substring(
      0,
      thisSubURL.indexOf("#") == -1
        ? thisSubURL.length
        : thisSubURL.indexOf("#")
    );
    thisSubURL = thisSubURL.substring(
      0,
      thisSubURL.indexOf("?") == -1
        ? thisSubURL.length
        : thisSubURL.indexOf("?")
    );
    thisSubURL = thisSubURL.substring(0, getPosition(thisSubURL, "/", 3));
    url = thisSubURL;
  }

  if (url == "/") {
    url = "/home";
  }

  return url;
}

function getPosition(string, subString, index) {
  return string.split(subString, index).join(subString).length;
}

// Preloader
$(window).on("load", function() {
  $(".preloader").fadeOut("slow");
});

$(function() {
  // Responsive Nav Toggle
  $(".menu-icon").on("click", function() {
    $(this)
      .add("#nav")
      .toggleClass("active");
  });

  // Testimonial Carousel
  $("#home__testimonials, #testimonials")
    .find(".accordion-container")
    .slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: false
    });

  // CMS Gallery Sliders
  $('.cms-gallery-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 4000
  });

  // Lightbox
  $(".content-block").magnificPopup({
    delegate: "img.rs-img",
    type: "image",
    closeOnContentClick: true,
    mainClass: "mfp-img-mobile",
    image: {
      verticalFit: true
    },
    callbacks: {
      elementParse: function (item) {
        let $src = item.el.attr('src'),
            $dataSrc = item.el.attr('data-mfp-src');
        item.src = $dataSrc ? $dataSrc : $src;
      }
    }
  });
});

// YouTube, Vimeo Video Ratio
var $allVideos = $(
    'iframe[src^="https://www.youtube.com"], iframe[src^="https://youtube.com"], iframe[src^="https://player.vimeo.com"]'
  ),
  $fluidEl = $(".container");

// Figure out and save aspect ratio for each video, and remove the hard coded width/height
$allVideos.each(function() {
  $(this)
    .data("aspectRatio", this.height / this.width)
    .removeAttr("height")
    .removeAttr("width");
});

// When the window is resized
$(window)
  .on("resize", function() {
    var newWidth = $fluidEl.width();

    // Resize all videos according to their own aspect ratio
    $allVideos.each(function() {
      var $el = $(this);
      $el.width(newWidth).height(newWidth * $el.data("aspectRatio"));
    });

    // Kick off one resize to fix all videos on page load
  })
  .trigger("resize");

// -- Auto Open Modal

$(function () {
  let $page = window.location.pathname,
      $timer = process.env.MIX_TRIAL_POPUP_TIMER,
      $popupState = sessionStorage.getItem('popup-state'),
      $isNews = window.location.href.indexOf('news') > -1,
      $allowedPages = process.env.MIX_TRIAL_POPUP_PAGES.split(','),
      $allowedPagesQuick = process.env.MIX_TRIAL_POPUP_PAGES_QUICK.split(',');

  if ($allowedPagesQuick.includes($page)) {
    $timer = process.env.MIX_TRIAL_POPUP_TIMER_QUICK;
  }

  if ($popupState !== 'hide' && ($allowedPages.includes($page) || $allowedPagesQuick.includes($page) || $isNews)) {
    setTimeout(function () {
      sessionStorage.setItem('popup-state', 'show');
      showModal('#trial');
    }, $timer);
  }
});

$(document).on('click', '#trial-modal .close-modal', function (e) {
  sessionStorage.setItem('popup-state', 'hide');
});

// -- Open Modals on click
$(document).on('click', '.trigger-modal', function (e) {
  e.preventDefault();

  let $tar = $(this).data('target');

  showModal('#' + $tar);
});

$('[href^="#show-modal-"]').on('click', function (e) {
  e.preventDefault();

  let $tar = $(this).attr('href').replace(/show-modal-/g, '');

  showModal($tar);
});

// -- Close Modals on click
$(document).on('click', '.close-modal', function (e) {
  e.preventDefault();

  let $tar = $(this).closest('.modal').attr('id');

  $('.overlay-modal').add('#' + $tar).hide();
  $('body').css({
    'position': 'static',
    'overflow': 'auto'
  });
});

$(function () {
  // -- Open form modals from external links
  $hash = window.location.hash;

  showModal($hash);

  // Toggle sections based on the value of Position [Modal]
  $('.position').on('change', function (e) {
    let $val = $(this).val(),
        $form = $(this).closest('form');

    if ($val == 'Student') {
      $form.find('.stop-student, .teaching-content, .area-content, .register-button').hide();
      $form.find('.show-student').show();
    } else if ($val == 'Teacher/Instructor') {
      $form.find('.stop-student, .teaching-content, .area-content, .register-button').show();
      $form.find('.show-student').hide();
    }
  });
});

// -- Open Trial modal from slider
$('[href*="#open-modal-slider"]').on('click', function (e) {
  e.preventDefault();

  showModal('#trial');
});

function showModal($tar) {
  if ($($tar + '-modal').length > 0) {
    $('.overlay-modal').add($tar + '-modal').show();
    $('body').css({
      'position': 'fixed',
      'overflow': 'hidden'
    });

    initTurnstile($tar.replace('#', ''));
  }
}

function initTurnstile($tar) {
  if ($('#' + $tar + '-modal [id^="cf-turnstile-container"]').length > 0) {
    turnstile.render('#cf-turnstile-container-' + $tar, {
      sitekey: process.env.MIX_TURNSTILE_KEY,
      callback: function (token) {
          // console.log(`Challenge Success ${token}`);
      }
    });
  }
}
